/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Andor application API
 * OpenAPI spec version: v1
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  ScrapeUrlBody,
  ScrapeUrlResponse
} from '../models';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  ANDOR_BASE_URL
} from '../api.base-url';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class PreviewsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(ANDOR_BASE_URL);
 scrapeUrl<TData = ScrapeUrlResponse>(scrapeUrlBody: ScrapeUrlBody, options?: HttpClientBodyOptions): Observable<TData>;
 scrapeUrl<TData = ScrapeUrlResponse>(scrapeUrlBody: ScrapeUrlBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 scrapeUrl<TData = ScrapeUrlResponse>(scrapeUrlBody: ScrapeUrlBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  scrapeUrl<TData = ScrapeUrlResponse>(
    scrapeUrlBody: ScrapeUrlBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/ogs`,
      scrapeUrlBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/ogs`,
      scrapeUrlBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/ogs`,
      scrapeUrlBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};
